import React from 'react';
var Pagination = function (props) {
    var outerClass = props.outerClass, numberOfPages = props.numberOfPages, _a = props.selectedPage, selectedPage = _a === void 0 ? 1 : _a, _b = props.previousBtnText, previousBtnText = _b === void 0 ? 'Previous' : _b, _c = props.nextBtnText, nextBtnText = _c === void 0 ? 'Next' : _c, _d = props.hideGoToEndButtons, hideGoToEndButtons = _d === void 0 ? false : _d, onPageChange = props.onPageChange, className = props.className;
    var renderNavigationItem = function (text, ariaLabel, enabled, page) {
        return enabled ? (React.createElement("li", { role: "presentation", className: "page-item" },
            React.createElement("button", { role: "menuitem", type: "button", tabIndex: -1, "aria-label": ariaLabel, className: "page-link", onClick: function (nativeEvent) {
                    return onPageChange && onPageChange(page, nativeEvent);
                } }, text))) : (React.createElement("li", { role: "presentation", className: "page-item disabled", "aria-hidden": "true" },
            React.createElement("span", { role: "menuitem", "aria-label": ariaLabel, "aria-disabled": "true", className: "page-link" }, text)));
    };
    var renderPageItem = function (index, pageNumber, active, disabled) {
        var className = ['page-item'];
        if (active)
            className.push('active');
        if (disabled)
            className.push('disabled');
        var formattedPageNumber = isPaginationExtension(pageNumber)
            ? '...'
            : pageNumber;
        return (React.createElement("li", { role: "presentation", className: className.join(' '), key: index },
            React.createElement("button", { role: "menuitemradio", type: "button", "aria-label": "Go to page " + formattedPageNumber, "aria-checked": active, "aria-posinset": pageNumber, "aria-setsize": 2, tabIndex: -1, className: "page-link", onClick: function (nativeEvent) {
                    return onPageChange && onPageChange(pageNumber, nativeEvent);
                } }, formattedPageNumber)));
    };
    var getValidSelectedPage = function (selectedPage) {
        if (selectedPage > numberOfPages) {
            return numberOfPages;
        }
        else if (selectedPage <= 1) {
            return numberOfPages === 0 ? 0 : 1;
        }
        else {
            return selectedPage;
        }
    };
    var getRange = function (start, end) {
        return Array(end - start + 1)
            .fill(1)
            .map(function (_, i) { return i + start; });
    };
    var isPaginationExtension = function (pageNumber) {
        return pageNumber === Number.MIN_VALUE || pageNumber === Number.MAX_VALUE;
    };
    var getVisiblePages = function (selectedPage, numberOfPages) {
        var delta = numberOfPages <= 7
            ? 7
            : selectedPage > 4 && selectedPage < numberOfPages - 3
                ? 2
                : 4;
        var range = {
            start: Math.round(selectedPage - delta / 2),
            end: Math.round(selectedPage + delta / 2)
        };
        if (range.start - 1 === 1 || range.end + 1 === numberOfPages) {
            range.start += 1;
            range.end += 1;
        }
        var pages = selectedPage > delta
            ? getRange(Math.min(range.start, numberOfPages - delta), Math.min(range.end, numberOfPages))
            : getRange(1, Math.min(numberOfPages, delta + 1));
        var withDots = function (value, pair) {
            return pages.length + 1 !== numberOfPages ? pair : [value];
        };
        if (pages[0] !== 1) {
            pages = withDots(1, [1, Number.MAX_VALUE]).concat(pages);
        }
        if (pages[pages.length - 1] < numberOfPages) {
            pages = pages.concat(withDots(numberOfPages, [Number.MIN_VALUE, numberOfPages]));
        }
        return pages;
    };
    var validSelectedPage = getValidSelectedPage(selectedPage);
    var canGoPrevious = validSelectedPage > 1;
    var canGoNext = validSelectedPage < numberOfPages;
    return (React.createElement("ul", { role: "menubar", "aria-disabled": "false", "aria-label": "Pagination", className: "pagination b-pagination pagination-md" + (outerClass ? " " + outerClass : '') + (className ? " " + className : '') },
        !hideGoToEndButtons &&
            renderNavigationItem('«', 'Go to first page', canGoPrevious, 1),
        renderNavigationItem(previousBtnText, 'Go to previous page', canGoPrevious, validSelectedPage - 1),
        getVisiblePages(validSelectedPage, numberOfPages).map(function (item, index) {
            return renderPageItem(index, item, item === validSelectedPage, isPaginationExtension(item));
        }),
        renderNavigationItem(nextBtnText, 'Go to next page', canGoNext, validSelectedPage + 1),
        !hideGoToEndButtons &&
            renderNavigationItem('»', 'Go to last page', canGoNext, numberOfPages)));
};
export default React.memo(Pagination);
